import * as React from "react";
import {ErrorMessage} from "@hookform/error-message";
import {useForm} from "react-hook-form";
import {RecipientInfo} from "../../../../libs/RecipientInfo";
import {EUnwrapStage} from "../../../models/UIModel";
import {UI} from "../../../UI";

// props for Puzzle Add form
interface IdentifyForm {
}

/**
 * Components for adding form
 *
 * @param props
 * @constructor
 */

export function IdentifyForm(props:IdentifyForm) {

    // react-hook/form initiallizer
    const { register, errors, handleSubmit, setError, trigger } = useForm({
        criteriaMode: 'all',
    });

    /**
     * On submit form does what is necessary when form is submitted
     * @param data
     */
    const onSubmit = async (data: any) => {

        // attempt to get record from email
        let success:boolean = await RecipientInfo.getRecordFromEmailAndPopulateUI(data.email)

        // if retrieved successfully
        if (success == true) {
            // move on to the next stage
            UI.UI_STORE.setStage(EUnwrapStage.Puzzle)
        }
        // otherwise
        else {
            // set error so user know we couldn't identify them
            setError("email", {type: "manual", message:"We couldn't find this email address. Give it another to try!"});
        }

    };

    // return the form control
    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div>
                <div className="form-label"><label className="form-label" htmlFor="email">Email</label></div>
                <input type="text" className={`${errors.email ? "form-input-error" : ""}`} name="email" ref={register({
                    required: "required",
                    pattern: {value: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i, message: "must be a valid email address"}})} />
                <ErrorMessage
                    errors={errors}
                    name="email"
                    render={({ messages }) => {
                        return messages
                            ? Object.entries(messages).map(([type, message]) => (
                                <p className="form-error" key={type}>{message}</p>
                            ))
                            : null;
                    }}
                />
                {errors.email && errors.email.type == "manual" ? <p className="form-error">{errors.email.message}</p>:""}
            </div>
            <input className="button-wide" type="submit" value="Unwrap It Now" />

        </form>
    );
}
